import request from '../../axios/axiosconfig.js'

//获取全局类型、状态
export function globalVariable(){
    return request({
        url: '/ps/common/globalVariable',
        method: 'get'
    })
}

//获取数据字典
export function dict(){
    return request({
        url: '/ps/common/dict',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/sys/dict.js